import { Col, Row } from "antd";
import React, { useEffect } from "react";
import Authbg from "../../Assets/Images/auth-img.png";
import cytologo from "../../Assets/logo/Doxzon Logo.svg";
import webIcon from "../../Assets/Images/webicon.jpg";

const AuthLayout = ({ children }) => {
  useEffect(() => {
    if (!document.querySelector("script[src*='translate_a/element.js']")) {
      const addScript = document.createElement("script");
      addScript.setAttribute(
        "src",
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
      );
      document.body.appendChild(addScript);
    }

    window.googleTranslateElementInit = () => {
      if (!document.getElementById("google_translate_element").innerHTML) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            autoDisplay: false,
          },
          "google_translate_element"
        );
      }
    };

    const interval = setInterval(() => {
      const comboBox = document.querySelector(".goog-te-combo");
      if (comboBox) {
        if (comboBox.options.length > 0) {
          comboBox.options[0].text = "English";
          comboBox.options[0].value = "";
          comboBox.selectedIndex = 0;
          clearInterval(interval);
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="h-screen"
      style={{ backgroundSize: "cover", backgroundPosition: "full" }}
    >
      <div>
        <div className="absolute top-4 right-4">
          <div
            id="google_translate_element"
            className=" rounded-lg flex items-center"
          ></div>
        </div>
        <div className="min-h-screen flex flex-col justify-center items-center w-screen h-screen">
          <div
            className="md:w-[35%] w-[80%] flex flex-col justify-center items-center shadow-2xl border rounded-md"
            style={{ margin: "0 auto" }}
          >
            <div className="mt-4 flex flex-col gap-1 justify-center items-center ">
              <img src={cytologo} alt="logo" className="w-32 h-10" />
              <span className="text-[12px]">Technology for Health</span>
            </div>
            <div className="text-center mt-2 text-xl text-[#189FAA] font-semibold ">
              Doctor
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
